import { useGoogleMaps } from "./useGoogleMaps";
import * as React from "react";

export function GoogleMapScript({ children }: { children?: React.ReactNode }) {
  const loading = useGoogleMaps();
  if (loading) {
    return null;
  }
  return <>{children}</> || null;
}
